import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { sessionExpiredState } from '../common/recoil/atom/SessionExpiredAtom';

/**
 * Returns a function that marks the session as expired ('hold' or 'idle').
 * First reason wins: if two timers fire close together, the one that was
 * already recorded is kept instead of being overwritten.
 * @returns {(reason: 'hold'|'idle') => void}
 */
export const useExpireSession = () => {
  const setSessionExpired = useSetRecoilState(sessionExpiredState);

  return useCallback(
    (reason) => {
      setSessionExpired((current) => current ?? reason);
    },
    [setSessionExpired],
  );
};
